"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var field_1 = require("../../layout/field/field");

var label_1 = require("../label/label");

var HyperlinkField = function (_super) {
  __extends(HyperlinkField, _super);

  function HyperlinkField() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  HyperlinkField.prototype.render = function () {
    var propsText = this.props.text;
    var linkText = propsText ? propsText : this.props.url;
    var label = this.props.label || '';
    var numberOfLines = this.props.allowWrap ? undefined : 1;
    return react_1.default.createElement(field_1.Field, {
      viewStyle: this.props.viewStyle
    }, react_1.default.createElement(label_1.Label, {
      label: label
    }, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.hyperlinkTextStyle,
      numberOfLines: numberOfLines
    }, react_1.default.createElement("a", {
      href: this.props.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, linkText))));
  };

  return HyperlinkField;
}(react_1.default.Component);

exports.HyperlinkField = HyperlinkField;